import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _httpClient: HttpClient
  ) { }

  // Get coupons report
  getCouponsReport (token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/couponsReport';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get coupons sales report
  getCouponsSalesReport (token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/couponsSalesReport';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get coupon detailed report
  getCouponDetailedReport (token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/couponDetailedReport';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get coupon redemption report
  getCouponRedemptionReport (token: string, body: any){
    const URL = environment.apiUrl + 'dashboard/couponRedemptionReport';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  // Get sales data
  getSalesData(token: string, retailerId : any, storeId: any, startDate: any, endDate: any){
    const URL = environment.apiUrl + 'dashboard/transactionData';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('retailer_id', retailerId)
      .set('store_id', storeId)
      .set('start_date', startDate)
      .set('end_date', endDate);

    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

}
